"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _lodash = _interopRequireDefault(require("lodash"));

var _postcss = _interopRequireDefault(require("postcss"));

var _postcssSelectorParser = _interopRequireDefault(require("postcss-selector-parser"));

var _generateVariantFunction = _interopRequireDefault(require("../util/generateVariantFunction"));

var _prefixSelector = _interopRequireDefault(require("../util/prefixSelector"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function generatePseudoClassVariant(pseudoClass) {
  var selectorPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : pseudoClass;
  return (0, _generateVariantFunction.default)(function (_ref) {
    var modifySelectors = _ref.modifySelectors,
        separator = _ref.separator;
    return modifySelectors(function (_ref2) {
      var selector = _ref2.selector;
      return (0, _postcssSelectorParser.default)(function (selectors) {
        selectors.walkClasses(function (sel) {
          sel.value = "".concat(selectorPrefix).concat(separator).concat(sel.value);
          sel.parent.insertAfter(sel, _postcssSelectorParser.default.pseudo({
            value: ":".concat(pseudoClass)
          }));
        });
      }).processSync(selector);
    });
  });
}

function ensureIncludesDefault(variants) {
  return variants.includes('default') ? variants : ['default'].concat(_toConsumableArray(variants));
}

var defaultVariantGenerators = function defaultVariantGenerators(config) {
  return {
    default: (0, _generateVariantFunction.default)(function () {}),
    'group-hover': (0, _generateVariantFunction.default)(function (_ref3) {
      var modifySelectors = _ref3.modifySelectors,
          separator = _ref3.separator;
      return modifySelectors(function (_ref4) {
        var selector = _ref4.selector;
        return (0, _postcssSelectorParser.default)(function (selectors) {
          selectors.walkClasses(function (sel) {
            sel.value = "group-hover".concat(separator).concat(sel.value);
            sel.parent.insertBefore(sel, (0, _postcssSelectorParser.default)().astSync((0, _prefixSelector.default)(config.prefix, '.group:hover ')));
          });
        }).processSync(selector);
      });
    }),
    'group-focus': (0, _generateVariantFunction.default)(function (_ref5) {
      var modifySelectors = _ref5.modifySelectors,
          separator = _ref5.separator;
      return modifySelectors(function (_ref6) {
        var selector = _ref6.selector;
        return (0, _postcssSelectorParser.default)(function (selectors) {
          selectors.walkClasses(function (sel) {
            sel.value = "group-focus".concat(separator).concat(sel.value);
            sel.parent.insertBefore(sel, (0, _postcssSelectorParser.default)().astSync((0, _prefixSelector.default)(config.prefix, '.group:focus ')));
          });
        }).processSync(selector);
      });
    }),
    hover: generatePseudoClassVariant('hover'),
    'focus-within': generatePseudoClassVariant('focus-within'),
    focus: generatePseudoClassVariant('focus'),
    active: generatePseudoClassVariant('active'),
    visited: generatePseudoClassVariant('visited'),
    disabled: generatePseudoClassVariant('disabled'),
    first: generatePseudoClassVariant('first-child', 'first'),
    last: generatePseudoClassVariant('last-child', 'last'),
    odd: generatePseudoClassVariant('nth-child(odd)', 'odd'),
    even: generatePseudoClassVariant('nth-child(even)', 'even')
  };
};

function _default(config, _ref7) {
  var pluginVariantGenerators = _ref7.variantGenerators;
  return function (css) {
    var variantGenerators = _objectSpread(_objectSpread({}, defaultVariantGenerators(config)), pluginVariantGenerators);

    css.walkAtRules('variants', function (atRule) {
      var variants = _postcss.default.list.comma(atRule.params).filter(function (variant) {
        return variant !== '';
      });

      if (variants.includes('responsive')) {
        var responsiveParent = _postcss.default.atRule({
          name: 'responsive'
        });

        atRule.before(responsiveParent);
        responsiveParent.append(atRule);
      }

      _lodash.default.forEach(_lodash.default.without(ensureIncludesDefault(variants), 'responsive'), function (variant) {
        variantGenerators[variant](atRule, config);
      });

      atRule.remove();
    });
  };
}